// 系统设置=>积分管理
import request from '@/plugins/axios'

const API_LIST = {
  POINTS_LOG_LIST: '/points/getPointsLogList',   //用户积分充值查询
  POINTS_ADD: '/points/addPoints',    //新增用户积分
  POINTS_USERINFO:'/points/getUserPointsInfo',//获取用户积分信息
  
}
//用户积分充值查询
export function getPointsLogListApi(params) {
  return request({ url: API_LIST.POINTS_LOG_LIST, method: 'get', params})
}

//新增用户积分
export function addPointsApi(data) {
  return request({ url: API_LIST.POINTS_ADD, method: 'post', data})
}

//获取用户积分信息
export function getUserPointsInfoApi(params) {
  return request({ url: API_LIST.POINTS_USERINFO, method: 'get', params})
}


